var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('navigation',{ref:"nav",attrs:{"user-info":this.user.profile},on:{"logout":_vm.logout}}),(_vm.isSearchOpened)?_c('div',{staticClass:"blured-body"}):_vm._e(),_c('main',{staticClass:"page-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }